
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getHistoryMessage } from "@/api/api-basic-websocket";
import qrcode from "@/components/qrcode/qrcode.vue";
import { calledMeasurementFee } from "@/api/api-basic-websocket";
import msgListDiv from "../../data-config/components/msg-list-div.vue";
import upgradeMadel from "./upgrade-madel.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-qrcode": qrcode,
    "pi-msg-list-div": msgListDiv,
    "pi-upgrade-madel": upgradeMadel
  }
})
export default class CollectionChargingOperation extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  private msgList!: object[];
  @Prop({
    default: () => {
      return {};
    }
  })
  private formInline!: objAny;
  private tiows!: objAny;
  @Prop({ default: 0 }) private isOpen!: number;

  private devLoginType = "1010";
  private devHeartbeat = "1020";
  private devFault = "1050";
  private devUpgrade = "2050";
  private msgType = 1;
  private tabsActive = "1";
  private codeArr = [["1010"], ["1020"], ["1050"], ["2050"]];

  private devLoginTypeList: object[] = [];
  private devHeartbeatList: object[] = [];
  private devFaultList: object[] = [];
  private devUpgradeList: object[] = [];

  private upgradeForm: objAny = {
    qrcode: "112313"
  };
  private form: objAny = {
    endTime: "",
    msgCodes: [],
    pageIndex: 1,
    pageSize: 10,
    pilePkId: "",
    startTime: ""
  };
  private upgradeTextObj: objAny = {
    // 202: "升级包版本",
    // 1009: "最大充电功率",
    // 1007: "最大充电电流",
    // 513: "SIM卡ICCID",
    // 1003: "禁止/允许离线充电",
    // 2024: "SIM卡信号强度",
    // 100: "联网方式",
    // 1010: "二维码",
    // 58: "复费率单价版本号"
    202: i18n.t("operData.202"),
    1009: i18n.t("operData.1009"),
    1007: i18n.t("operData.1007"),
    513: i18n.t("operData.513"),
    1003: i18n.t("operData.1003"),
    2024: i18n.t("operData.2024"),
    100: i18n.t("operData.100"),
    1010: i18n.t("operData.1010"),
    58: i18n.t("operData.58"),
    310003: i18n.t("equipmentModel.deviceModelName")
  };
  private upgradeInput: objAny = {
    202: "",
    1009: "",
    1007: "",
    513: "",
    1003: "",
    2024: "",
    100: "",
    1010: "",
    58: "",
    310003: ""
  };
  private networkingType: objAny = {
    1: "4g",
    2: i18n.t("operData.ethernet"),
    3: "WIFI"
  };
  private formObj: objAny = {};
  // private devLoginList: objAny = [];
  // private devHeartbeatList: objAny = [];
  // private devFaultList: objAny = [];
  // private devUpgradeList: objAny = [];
  private pointValueList: objAny = [];

  public clearMsg() {
    this.devLoginTypeList = [];
    this.devHeartbeatList = [];
    this.devFaultList = [];
    this.devUpgradeList = [];
  }
  public append(data: objAny) {
    // const devLoginTypeList: objAny = [];

    if (data.msgCode == this.devLoginType) {
      this.devLoginTypeList.push(data);
    } else if (data.msgCode == this.devHeartbeat) {
      this.devHeartbeatList.push(data);
    } else if (data.msgCode == this.devFault) {
      this.devFaultList.push(data);
    } else if (data.msgCode == this.devUpgrade) {
      this.devUpgradeList.push(data);
    }
  }
  public queryClick() {
    if (!this.form.startTime || this.form.startTime == "") {
      this.$Message.error(i18n.t("formText.selectTimePl"));
    } else {
      this.formObj[this.tabsActive].isAll = false;
      this.formObj[this.tabsActive].form.pageIndex = 1;
      this.formObj[this.tabsActive].form.startTime = this.form.startTime;
      this.formObj[this.tabsActive].form.endTime = this.form.endTime;
      this.formObj[this.tabsActive].form.pilePkId = this.formInline.pilePkId;
      this.formObj[this.tabsActive].list = [];

      this.getHistoryMessage();
    }
  }

  async getHistoryMessage() {
    const ret = await getHistoryMessage(this.formObj[this.tabsActive].form);
    if (ret.status == this["$config"].apiStatus) {
      const list = this.formObj[this.tabsActive].list;
      this.formObj[this.tabsActive].list = list.concat(ret.data);

      if (list.length >= ret.total) {
        this.formObj[this.tabsActive].isAll = true;
      }
    }
  }
  public timeChange(val: string[]) {
    this.form.startTime = val[0];
    this.form.endTime = val[1];
  }

  public init() {
    const obj: objAny = {};
    for (let i = 1; i < 5; i++) {
      const form = JSON.parse(JSON.stringify(this.form));
      form.msgCodes = this.codeArr[i - 1];
      obj[i] = {
        form: form,
        list: [],
        isAll: false
      };
    }
    this.formObj = obj;
  }

  public loadingMore() {
    this.formObj[this.tabsActive].form.pageIndex++;
    this.getHistoryMessage();
  }
  public getPile() {
    for (const i in this.upgradeInput) {
      this.upgradeInput[i] = "";
    }
    // this.pointValueList = [];
    this.calledMeasurementFee(5);
  }
  async calledMeasurementFee(type: number) {
    const ret = await calledMeasurementFee({
      pilePkId: this.formInline.pilePkId,
      type: type,
      content: "",
      gunPkId: this.formInline.gunPkId
    });
    if (ret.status == this["$config"].apiStatus) {
      // console.log("召测");
      this.$Message.success(i18n.t("operData.sendSuccess"));
    }
  }
  public upgradeClick() {
    const upgradeMadel: objAny = this.$refs.upgradeMadel;
    upgradeMadel.open(this.formInline.pilePkId);
    // this.calledMeasurementFee(3);
  }

  public getUpgradeData(data: objAny) {
    const list: object[] = data.pointValueList || [];
    list.map((item: objAny) => {
      if (item.ioAddr == "1003") {
        this.upgradeInput[item.ioAddr] =
          item.value == 1
            ? i18n.t("operData.allow")
            : i18n.t("operData.prohibit");
      } else if (item.ioAddr == "100") {
        this.upgradeInput[item.ioAddr] = this.networkingType[item.value];
      } else {
        this.upgradeInput[item.ioAddr] = item.value;
      }
    });
    console.log(this.upgradeInput);
    // if (this.pointValueList.length == 0) {
    //   this.pointValueList = list;
    // } else {
    //   this.pointValueList = this.pointValueList.concat(list);
    // }
  }

  created() {
    this.init();
  }
}
